var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.renderComponent)?_c('List',{attrs:{"headers":_vm.headers,"formview":_vm.formview,"table":_vm.table,"addbutton":false,"default_limit":'500',"default_sort":'id',"default_sort_typ":'ASC',"extension":''}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }